import { Helmet } from "react-helmet";
import CustomLink from "../../components/elements/CustomLink";

const Section = ({ title, children }) => (
  <div className="flex flex-col">
    <header className="text-center px-4">
      <h1 className="text-gold text-3xl">{title}</h1>
    </header>
    {children}
  </div>
);

export const drivesContent = [
  {
    title: "Turning Every Play into an Opportunity",
    body: (
      <>
        <p>
          <strong className="text-white">Drives Football</strong> is where the
          Drives Score was born — and where its full potential is on display.
          Designed to quantify the situational value of each offensive
          possession, the Drives Score transforms football from a series of
          disconnected plays into a continuous stream of measurable, tradable
          insights.`,
        </p>
      </>
    ),
  },
  {
    title: "From Watching to Playing",
    body: `Drives enhances the live football experience by layering insight and interaction directly into the gaming experience. It doesn’t just surface odds — it gives fans, analysts, and bettors real tools to understand and engage with the game in real time.`,
  },
  {
    title: "Game Analysis: Drives Score, DSA & Insights",
    body: (
      <>
        <p>
          <strong className="text-gold">Drives Score</strong> represents the
          expected points of an offensive possession — recalculated in real time
          based on field position, down, distance, clock, and score. It updates
          after every play.
        </p>
        <p>
          <strong className="text-gold">Drives Score Added (DSA)</strong>{" "}
          measures how much each play moves that expectation — quantifying the
          true impact of big plays, takeaways, sacks, penalties, and more. It
          captures not just what happened, but how much it mattered.
        </p>
        <p>
          Our broader analytics framework builds on DS and DSA to separate
          meaningful production from garbage-time stats, highlight clutch plays
          in critical moments, and measure team efficiency under pressure. These
          insights feed content, sharpen analysis, and inform smarter betting
          decisions — all in real time.
        </p>
      </>
    ),
  },
  {
    title: "Live Insights: See Drives in Action",
    body: (
      <>
        <p>
          Watch the Experience: In this broadcast-integrated example, a live
          Drives Score ticker updates after every play, flashing green (gain) or
          red (loss) to reflect changing scoring probabilities — a visual
          representation of Drives Score in action.
        </p>

        <div className="flex flex-col items-center gap-2">
          <img
            src={require("../../assets/images/tv-link-placeholder.png")}
            alt="TV"
            className="w-full lg:w-[900px] h-[200px] md:h-[450px]"
          />
          <CustomLink to="/tv">
            <p className="underline">Watch the Drives infographic</p>
          </CustomLink>
        </div>

        <p>
          Betting Overlay: This version brings the full betting experience into
          the broadcast, letting users view odds and place wagers directly on
          the web app as the game unfolds. Every play becomes a live betting
          opportunity — seamlessly integrated into the viewing experience.
        </p>

        <div className="flex flex-col items-center gap-2">
          <img
            src={require("../../assets/images/broadcast-link-placeholder.png")}
            alt="Broadcast"
            className="w-full lg:w-[900px] h-[200px] md:h-[450px]"
          />

          <CustomLink to="/broadcast">
            <p className="underline">Play Drives</p>
          </CustomLink>
        </div>
      </>
    ),
  },

  {
    title: "The Betting Product: Real-Time Market Intelligence",
    body: (
      <>
        <ul className="list-disc text-left mt-3 w-full">
          <li>
            The Drives Score powers a new kind of live betting — fast,
            continuous, and data-driven.
          </li>
          <li>
            Play-by-Play Markets: Users can buy or sell drive outcomes at any
            stoppage in play.
          </li>
          <li>
            Market-Driven Pricing: Wager flows adjust prices in real time,
            introducing a “wisdom of the crowd” element that directly influences
            the Drives Score.
          </li>
          <li>
            Insight-Driven Experience: Betting is shaped not just by odds, but
            by context-aware analytics like Drives Score, DSA, and our advanced
            metrics.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: null,
    body: (
      <>
        <p>
          Football’s natural structure — with distinct drives, high-impact
          moments, and predictable stoppages — makes it the perfect fit for
          real-time, continuous betting. Each play is a moment of consequence,
          and Drives captures that tension in market form.
        </p>
        <p>
          Drives doesn’t just make betting more interactive — it makes watching
          smarter, commentary richer, and engagement deeper.
        </p>
      </>
    ),
  },
];

export default function Football() {
  return (
    <section className="section about-section">
      <Helmet>
        <title>Football</title>
      </Helmet>

      <div className="flex flex-col container">
        {drivesContent.map((data, index) =>
          data.children ? (
            <div className="flex flex-col items-center">
              <div className="mt-14 pb-24">{data.children}</div>
            </div>
          ) : (
            <Section key={index} title={data.title} children={data.body} />
          )
        )}
      </div>
    </section>
  );
}
